import React from "react";
import { education } from "../mock";
import { GraduationCap, MapPin, Award, BookOpen } from "lucide-react";

const Education = () => {
  return (
    <section
      id="education"
      className="section-padding bg-[#0a0a0a] text-[#f4f1ea] relative overflow-hidden"
    >
      <div
        className="absolute top-1/2 -right-40 w-[500px] h-[500px] rounded-full pointer-events-none -translate-y-1/2"
        style={{
          background:
            "radial-gradient(circle, rgba(160,29,63,0.06) 0%, transparent 70%)",
        }}
      />

      <div className="container-x relative">
        <div className="grid grid-cols-12 gap-y-10 md:gap-x-12 items-end mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-7">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#a01d3f] mb-6">
              <span className="text-[#f4f1ea]/40">[ 04 ]</span> &nbsp;—&nbsp;
              Foundation
            </p>
            <h2 className="font-display text-4xl md:text-6xl font-semibold leading-[1] tracking-tight">
              Education
              <br />
              <span className="italic font-light text-white">
                &amp; the basics.
              </span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5">
            <p className="text-base text-[#f4f1ea]/65 leading-relaxed max-w-md md:ml-auto">
              Where the fundamentals were forged, algorithms, systems, and the
              discipline to keep learning long after graduation.
            </p>
          </div>
        </div>

        <div className="space-y-4 md:space-y-5">
          {education.map((edu) => (
            <div
              key={edu.id}
              className="group relative rounded-2xl bg-gradient-to-br from-[#a01d3f]/10 via-[#121212] to-[#0f0f0f] border border-[#a01d3f]/30 p-6 md:p-8 transition-all duration-300 hover:border-[#a01d3f] hover:-translate-y-1 hover:shadow-[0_20px_50px_-18px_rgba(160,29,63,0.5)] overflow-hidden"
            >
              <span className="absolute left-0 top-0 bottom-0 w-[3px] rounded-l-2xl bg-[#a01d3f]/40 group-hover:bg-[#a01d3f] transition-colors duration-300" />

              <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-[#a01d3f]/15 blur-3xl pointer-events-none opacity-50 group-hover:opacity-100 transition-opacity duration-500" />

              <div className="relative flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#a01d3f] to-[#861732] flex items-center justify-center shrink-0 shadow-[0_5px_16px_-2px_rgba(160,29,63,0.55)] group-hover:shadow-[0_8px_22px_-2px_rgba(160,29,63,0.75)] transition-shadow duration-300">
                    <GraduationCap
                      size={20}
                      strokeWidth={1.6}
                      className="text-[#f4f1ea]"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="font-mono text-[10px] uppercase tracking-widest text-[#a01d3f]">
                      / {edu.period}
                    </span>
                    <h3 className="mt-2 font-display text-2xl md:text-3xl font-semibold tracking-tight leading-tight">
                      {edu.degree}
                    </h3>
                    <div className="mt-3 flex items-center gap-2 text-sm text-[#f4f1ea]/75 mb-1">
                      <BookOpen size={13} className="text-[#a01d3f] shrink-0" />
                      <span className="font-medium">{edu.school}</span>
                    </div>
                    <div className="flex items-center gap-2 text-xs text-[#f4f1ea]/50">
                      <MapPin size={11} />
                      <span>{edu.location}</span>
                    </div>
                  </div>
                </div>

                {edu.honors && (
                  <div className="flex items-center gap-2.5 px-4 py-2.5 rounded-lg bg-gradient-to-br from-[#a01d3f] to-[#861732] self-start shrink-0 shadow-[0_5px_16px_-3px_rgba(160,29,63,0.55)]">
                    <Award size={14} className="text-[#f4f1ea]" />
                    <span className="font-mono text-xs font-medium text-[#f4f1ea]">
                      {edu.honors}
                    </span>
                  </div>
                )}
              </div>

              {edu.description && (
                <p className="relative mt-6 pt-5 border-t border-[#f4f1ea]/8 text-sm text-[#f4f1ea]/72 leading-relaxed">
                  {edu.description}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
